/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Вексель
 */
export interface PromNote {
  /**
   * ИД векселя
   * @format uuid
   */
  id?: string;

  /** Серия векселя */
  series?: string;

  /** Номер заявки */
  number?: string;

  /** Статус заявки */
  state?: string;

  /**
   * Дата составления
   * @format date
   */
  beginDate?: string;

  /** Общий номинал по заявке */
  nominal?: number;

  /** Валюта всех векселей в заявке */
  nominalCurrCode?: string;

  /** Процентная ставка */
  rate?: number;

  /** Срок погашения */
  paymentTerm?: string;

  /** Список привилегий пользователя */
  permissions?: PermissionResponse[];

  /**
   * Дата погашения векселя
   * @format date
   */
  endDate?: string;
}

/**
 * Блок векселей
 */
export interface PromissoryBlock {
  /** Признак создания документа */
  isDraft?: boolean;

  /**
   * Тип заявки
   * @example PAYMENT
   */
  type?: string;

  /**
   * Дата перевода средств
   * @format date
   * @example 2024-10-02
   */
  refundDate?: string;

  /** Расчетный счет */
  account?: string;

  /** БИК */
  bic?: string;

  /** Список векселей */
  promNotes?: PromNote[];
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Заявка на операцию с векселями
 */
export interface UpdateStatusRequest {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id: string;
}

/**
 * Пустой ответ
 */
export type EmptyResponse = object;

/**
 * Изменение статуса соглашения
 */
export interface UpdateAgreementStatusRequest {
  /**
   * ИД соглашения
   * @format uuid
   */
  agreementId?: string;
}

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Заявка
 */
export interface PromRequest {
  /**
   * ИД заявки
   * @format uuid
   */
  id?: string;

  /** Тип заявки */
  requestType?: string;

  /**
   * Номер заявки
   * @format int32
   */
  requestNumber?: number;

  /** Статус заявки */
  state?: string;

  /**
   * Дата создания заявки. Формат "гггг-мм-ддТчч:мм:сс" с корректировкой на timezone
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата и время направления заявки в Банк. Если статус не SENT, но отправлено, не отображать. Формат "гггг-мм-ддТчч:мм:сс" с корректировкой на timezone
   * @format date-time
   */
  sendDate?: string;

  /**
   * Количество векселей в заявке
   * @format int32
   */
  count?: number;

  /** Общий номинал по заявке */
  totalNominal?: number;

  /** Валюта всех векселей в заявке */
  nominalCurr?: string;

  /**
   * Дата погашения
   * @format date
   */
  refundDate?: string;

  /** Список привилегий пользователя */
  permissions?: PermissionResponse[];
}

/**
 * Заявки
 */
export interface PromissoryNoteForClientList {
  /** Признак, что есть еще данные для ответа */
  hasMore?: boolean;

  /**
   * Количество элементов в ответе
   * @format int32
   */
  size?: number;

  /** Список заявок на приобретение векселей */
  data?: PromRequest[];
}

/**
 * Вексель
 */
export interface PromNoteForRequestList {
  /**
   * ИД векселя в заявке
   * @format uuid
   */
  id?: string;

  /** Серия векселя */
  series?: string;

  /** Номер векселя */
  number?: string;

  /**
   * ИД векселя
   * @format uuid
   */
  promissoryId?: string;

  /** Сумма размещения (номинал векселя) */
  nominal?: number;

  /** Валюта размещения (валюта номинала) */
  currCode?: string;

  /**
   * Дата размещения (составления векселя)
   * @format date
   * @example 2024-10-02
   */
  beginDate?: string;

  /**
   * Дата погашения векселя
   * @format date
   * @example 2024-10-02
   */
  endDate?: string;

  /**
   * Срок векселя в днях
   * @format int64
   */
  term?: number;

  /** Процентная ставка */
  rate?: number;
}

/**
 * Заявка на операцию с векселями
 */
export interface PromissoryNoteRequestDetailResponse {
  /**
   * ИД заявки
   * @format uuid
   */
  id?: string;

  /** Тип заявки */
  requestType?: string;

  /** Номер заявки */
  requestNumber?: string;

  /**
   * ИД клиента
   * @format uuid
   */
  clientId?: string;

  /** Короткое наименование клиента */
  shortName?: string;

  /** ИНН клиента */
  inn?: string;

  /** Филиал клиента */
  branchCode?: string;

  /** Статус заявки */
  state?: string;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата и время направления заявки в Банк
   * @format date-time
   */
  sendDate?: string;

  /**
   * Количество векселей в заявке
   * @format int32
   */
  count?: number;

  /** Общий номинал по заявке */
  totalNominal?: number;

  /** Валюта всех векселей в заявке */
  nominalCurr?: string;

  /** Расчетный счет */
  account?: string;

  /** Наименование банка */
  bankName?: string;

  /** Корр. счет */
  corrAccount?: string;

  /**
   * ИД банка
   * @format uuid
   */
  bankId?: string;

  /** БИК */
  bik?: string;

  /** Дата погашения */
  refundDate?: string;

  /** Список векселей */
  promNotes?: PromNoteForRequestList[];

  /** Список привилегий пользователя */
  permissions?: PermissionResponse[];

  /** Список подписей */
  signatures?: SignatureForRequestDetail[];
}

/**
 * Список подписей
 */
export interface SignatureForRequestDetail {
  /** ФИО уполномоченного лица */
  fio?: string;

  /**
   * Дата подписания
   * @format date-time
   */
  signDate?: string;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Ответ со списком разрешений клиента
 */
export interface ClientPermissionResponse {
  /** Тип документа */
  entityStrId?: "PRMS_REQUEST" | "PRMS_AGREEMENT" | "PRMS_BILL";

  /** Список разрешений */
  permissions?: PermissionResponse[];
}

/**
 * ККБ Соглашения
 */
export interface AgreementCcb {
  /**
   * Идентификатор соглашения
   * @format uuid
   */
  id?: string;

  /** ИД сделки в СОФР */
  sofrId?: string;

  /** Тип соглашения */
  type?: string;

  /** Номер соглашения */
  number?: string;

  /** Короткое наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** Код филиала */
  branchCode?: string;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  contractDate?: string;

  /**
   * Дата приобретения векселей
   * @format date
   */
  buyDate?: string;

  /** Место составления векселей */
  buyAddress?: string;

  /** Место платежа по векселям */
  paymentAddress?: string;

  /**
   * Дата погашения
   * @format date
   */
  refundDate?: string;

  /** Счет для перечисления средств */
  account?: string;

  /** Корр счет */
  corrAccount?: string;

  /** Наименование банка */
  bankName?: string;

  /** БИК банка */
  bik?: string;

  /** Список векселей в соглашении */
  bills?: PromNoteForAgreementCcb[];
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = RequestCcb | AgreementCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

export interface PromNoteForAgreementCcb {
  /** Серия */
  series?: string;

  /** Номер */
  number?: string;

  /** Номинал */
  nominal?: number;

  /** Валюта номинала */
  currCode?: string;

  /** Цена при покупке */
  buyPrice?: number;

  /** Валюта покупки */
  buyCurr?: string;

  /** Процентная ставка */
  rate?: number;

  /**
   * Дата составления векселя
   * @format date
   */
  beginDate?: string;

  /** Срок платежа */
  paymentTerm?: string;

  /** Счет перевода средств на покупку векселя */
  account?: string;

  /** Цена векселя при досрочной продаже */
  salePrice?: number;

  /** Валюта цены */
  saleCurr?: string;
}

export interface PromNoteForRequestCcb {
  /** Серия */
  series?: string;

  /** Номер */
  number?: string;

  /** Номинал */
  nominal?: number;

  /** Валюта номинала */
  currCode?: string;

  /** Процентная ставка */
  rate?: number;

  /**
   * Дата составления векселя
   * @format date
   */
  beginDate?: string;

  /** Срок платежа */
  paymentTerm?: string;
}

/**
 * ККБ Заявки на операцию с векселями
 */
export interface RequestCcb {
  /**
   * Идентификатор заявки
   * @format uuid
   */
  id?: string;

  /** Тип заявления */
  type?: string;

  /** Номер заявки */
  number?: string;

  /** Короткое наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** Код филиала */
  branchCode?: string;

  /**
   * Дата создания заявления с учетом временной зоны филиала
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата погашения
   * @format date
   */
  refundDate?: string;

  /** Счет для перечисления средств */
  account?: string;

  /** Корр счет */
  corrAccount?: string;

  /** Наименование банка */
  bankName?: string;

  /** БИК банка */
  bik?: string;

  /** Список векселей в заявке */
  bills?: PromNoteForRequestCcb[];
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Вексели
 */
export interface PromissoryNoteList {
  /** Признак, что есть еще данные для ответа */
  hasMore?: boolean;

  /**
   * Количество элементов в ответе
   * @format int32
   */
  size?: number;

  /** Список векселей */
  data?: PromNote[];
}

/**
 * Информация о соглашении на приобретение
 */
export interface BuyAgreement {
  /**
   * ИД самого позднего соглашения на приобретение этого векселя
   * @format uuid
   */
  buyAgrId?: string;

  /** Название соглашения */
  name?: string;
}

/**
 * Заявка на операцию с векселем
 */
export interface PaymentReq {
  /**
   * ИД заявки на погашение
   * @format uuid
   */
  paymentId?: string;

  /** Название заявки */
  name?: string;

  /** Статус заявки */
  state?: string;
}

/**
 * Вексель
 */
export interface PromissoryDetail {
  /**
   * ИД векселя
   * @format uuid
   */
  id?: string;

  /** Серия векселя */
  series?: string;

  /** Номер заявки */
  number?: string;

  /** Статус заявки */
  state?: string;

  /**
   * Дата составления
   * @format date
   */
  beginDate?: string;

  /** Общий номинал по заявке */
  nominal?: number;

  /** Валюта всех векселей в заявке */
  nominalCurrCode?: string;

  /** Процентная ставка */
  rate?: number;

  /** Срок погашения */
  paymentTerm?: string;

  /**
   * Количество дней до возможности срочного погашения
   * @format int64
   */
  term?: number;

  /** Список привилегий пользователя */
  permissions?: PermissionResponse[];

  /**
   * Дата погашения векселя
   * @format date
   */
  endDate?: string;

  /** Список заявок на операцию с векселем */
  paymentReqs?: PaymentReq[];

  /** Информация о соглашении на приобретение */
  buyAgreement?: BuyAgreement;

  /** Информация о соглашении на досрочное погашение */
  refundAgreement?: RefundAgreement;
}

/**
 * Информация о соглашении на досрочное погашение
 */
export interface RefundAgreement {
  /**
   * ИД самого позднего соглашения на досрочное погашение этого векселя
   * @format uuid
   */
  refundAgrId?: string;

  /** Название соглашения */
  name?: string;
}

/**
 * Ответ со списком банков
 */
export interface BankResponse {
  /** Признак, что есть еще данные для ответа */
  hasMore?: boolean;

  /** Список банков */
  data?: RuBank[];
}

/**
 * Банк
 */
export interface RuBank {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Название банка */
  name?: string;

  /** БИК */
  bic?: string;

  /** Корр. счет */
  corrAccount?: string;

  /** Населенный пункт */
  place?: string;
}

/**
 * Соглашение
 */
export interface Agreement {
  /**
   * ИД соглашения
   * @format uuid
   */
  id?: string;

  /** Тип соглашения. BUY - соглашение о приобретении, REFUND - соглашение о досрочном выкупе */
  type?: string;

  /**
   * ИД клиента
   * @format uuid
   */
  clientId?: string;

  /** Номер соглашения */
  agrNumber?: string;

  /** Статус соглашения */
  state?: string;

  /**
   * Дата приобретения векселей, заполняется для договора BUY
   * @format date
   */
  buyDate?: string;

  /** Место составления векселей */
  buyAddress?: string;

  /** Место платежа по векселям */
  paymentAddress?: string;

  /**
   * Дата досрочного погашения
   * @format date
   */
  refundDate?: string;

  /**
   * Количество векселей
   * @format int32
   */
  billCount?: number;

  /** Общая сумма по номиналу */
  billNominal?: number;

  /** Валюта номинала */
  nominalCurr?: string;

  /** Список привилегий пользователя */
  permissions?: Permission[];
}

/**
 * Список соглашений для клиента
 */
export interface AgreementList {
  /** Признак, что есть еще данные для ответа */
  hasMore?: boolean;

  /**
   * Количество элементов в ответе
   * @format int32
   */
  size?: number;

  /** Список соглашений */
  data?: Agreement[];
}

/**
 * Полномочие
 */
export interface Permission {
  /** Название действия */
  name: string;

  /** Признак доступности действия */
  isAvailable: boolean;

  /** Описание действия */
  desc: string;
}

/**
 * Подробная информация о соглашении
 */
export interface AgreementDetail {
  /**
   * ИД соглашения
   * @format uuid
   */
  id?: string;

  /** Тип соглашения. BUY - соглашение о приобретении, REFUND - соглашение о досрочном погашении */
  type?: string;

  /**
   * ИД клиента
   * @format uuid
   */
  clientId?: string;

  /** Короткое наименование клиента, как указано в соглашении */
  shortName?: string;

  /** Номер соглашения из СОФР */
  agrNumber?: string;

  /** ИНН клиента */
  inn?: string;

  /** Филиал клиента, возвращаем первые 2 символа */
  branchCode?: string;

  /** Статус соглашения */
  state?: string;

  /**
   * Дата создания соглашения. Формат "гггг-мм-ддТчч:мм:сс" с корректировкой на timezone
   * @format date-time
   */
  createDate?: string;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата договора в формате гггг-мм-дд
   * @format date
   */
  contractDate?: string;

  /**
   * Дата приобретения векселей, заполняется для типа BUY в формате гггг-мм-дд
   * @format date
   */
  buyDate?: string;

  /** Место составления векселей */
  buyAddress?: string;

  /** Место платежа по векселям */
  paymentAddress?: string;

  /**
   * Дата досрочного погашения для типа REFUND в формате гггг-мм-дд
   * @format date
   */
  refundDate?: string;

  /** Расчетный счет для перевода средств */
  account?: string;

  /**
   * ИД банка
   * @format uuid
   */
  bankId?: string;

  /** Наименование банка */
  bankName?: string;

  /** БИК банка */
  bik?: string;

  /** Список векселей в соглашении */
  promNotes?: PromNoteToAgreementBank[];

  /** Список привилегий пользователя */
  permissions?: Permission[];
}

/**
 * Вексель для Соглашения
 */
export interface PromNoteToAgreementBank {
  /** Сумма размещения (номинал векселя) */
  nominal?: number;

  /** Валюта размещения (валюта номинала) */
  currCode?: string;

  /**
   * Дата размещения (составления векселя)
   * @format date
   * @example 2024-10-02
   */
  beginDate?: string;

  /**
   * Дата погашения векселя
   * @format date
   * @example 2024-10-02
   */
  endDate?: string;

  /** Срок платежа */
  paymentTerm?: string;

  /**
   * ИД векселя
   * @format uuid
   */
  promissoryId?: string;

  /** Серия векселя */
  series?: string;

  /** Номер векселя */
  number?: string;

  /** Процентная ставка */
  rate?: number;

  /** Цена Векселя */
  billPrice?: number;

  /** Валюта цены векселя */
  billCurr?: string;

  /** Cчет */
  account?: string;
}

export interface Account {
  /**
   * ID счета
   * @format uuid
   */
  id?: string;

  /**
   * Состояние счета
   * @example state
   */
  state?: string;

  /**
   * Наименование счета
   * @example name
   */
  name?: string;

  /**
   * Валюта счета
   * @example currency
   */
  currency?: string;

  /**
   * Номер счета
   * @example number
   */
  number?: string;

  /**
   * Тип счета
   * @example type
   */
  type?: string;

  /**
   * Дата открытия счета
   * @format date
   */
  openDate?: string;
}

export interface GetAllPromRequestsParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  type?: string;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
}

export interface GetCcbParams {
  /** @format uuid */
  documentId: string;
  documentType: string;
}

export interface GetAllPromNotesParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  statuses?: string[];

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;

  /** @format date */
  createStartDate?: string;

  /** @format date */
  createEndDate?: string;
  number?: string;
  forPayment?: boolean;
  nominalCurr?: string;
}

export interface GetRuBanksParams {
  search: string;
}

export interface GetAllAgreementParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  type?: string;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  stateList?: string[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-promissory-notes
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-promissory-notes.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name GetAllPromRequests
     * @summary Получение списка заявок
     * @request GET:/api/promissory-notes/v1/external/promissory-request
     * @secure
     */
    getAllPromRequests: (
      query: GetAllPromRequestsParams,
      params: RequestParams = {}
    ) =>
      this.request<PromissoryNoteForClientList, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name CreatePromNotes
     * @summary Создание заявки на операцию с векселями Банка
     * @request POST:/api/promissory-notes/v1/external/promissory-request
     * @secure
     */
    createPromNotes: (data: PromissoryBlock, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name GetPromRequest
     * @summary Получение деталей заявки
     * @request GET:/api/promissory-notes/v1/external/promissory-request/{id}
     * @secure
     */
    getPromRequest: (id: string, params: RequestParams = {}) =>
      this.request<PromissoryNoteRequestDetailResponse, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name EditPromNotes
     * @summary Редактирование заявки на операцию с векселями Банка
     * @request POST:/api/promissory-notes/v1/external/promissory-request/{id}
     * @secure
     */
    editPromNotes: (
      id: string,
      data: PromissoryBlock,
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name DeletePromNotes
     * @summary Удаление заявки на операцию с векселями Банка
     * @request DELETE:/api/promissory-notes/v1/external/promissory-request/{id}
     * @secure
     */
    deletePromNotes: (id: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name UpdateStatus
     * @summary Обновление статуса заявки на операцию с векселями
     * @request POST:/api/promissory-notes/v1/external/promissory-request/update-status
     * @secure
     */
    updateStatus: (data: UpdateStatusRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request/update-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Соглашения
     * @name UpdateAgreementStatus
     * @summary Обновление статуса соглашения об операции с векселями
     * @request POST:/api/promissory-notes/v1/external/agreement/update-status
     * @secure
     */
    updateAgreementStatus: (
      data: UpdateAgreementStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/promissory-notes/v1/external/agreement/update-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на операцию с векселями
     * @name PrintPromNote
     * @summary Печать заявки на операцию с векселями Банка
     * @request GET:/api/promissory-notes/v1/external/promissory-request/print/{id}
     * @secure
     */
    printPromNote: (id: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/promissory-notes/v1/external/promissory-request/print/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Разрешения
     * @name GetClientPermissions
     * @summary Получение списка разрешений клиента
     * @request GET:/api/promissory-notes/v1/external/permissions/{entityStrId}
     * @secure
     */
    getClientPermissions: (
      entityStrId: "PRMS_REQUEST" | "PRMS_AGREEMENT" | "PRMS_BILL",
      params: RequestParams = {}
    ) =>
      this.request<ClientPermissionResponse, GenericError | ErrorMessage>({
        path: `/api/promissory-notes/v1/external/permissions/${entityStrId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Подтверждения
     * @name GetCcb
     * @summary Получение ККБ документа
     * @request GET:/api/promissory-notes/v1/external/confirmation/order-ccb
     * @secure
     */
    getCcb: (query: GetCcbParams, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, void>({
        path: `/api/promissory-notes/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/promissory-notes/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, void>({
        path: `/api/promissory-notes/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Управление сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/promissory-notes/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, void>({
        path: `/api/promissory-notes/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Векселя
     * @name GetAllPromNotes
     * @summary Получение списка векселей
     * @request GET:/api/promissory-notes/v1/external/bill
     * @secure
     */
    getAllPromNotes: (
      query: GetAllPromNotesParams,
      params: RequestParams = {}
    ) =>
      this.request<PromissoryNoteList, GenericError>({
        path: `/api/promissory-notes/v1/external/bill`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Векселя
     * @name GetPromNote
     * @summary Получение деталей векселя
     * @request GET:/api/promissory-notes/v1/external/bill/{id}
     * @secure
     */
    getPromNote: (id: string, params: RequestParams = {}) =>
      this.request<PromissoryDetail, GenericError>({
        path: `/api/promissory-notes/v1/external/bill/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Банки
     * @name GetRuBanks
     * @summary Получение списка Российских банков
     * @request GET:/api/promissory-notes/v1/external/banks
     * @secure
     */
    getRuBanks: (query: GetRuBanksParams, params: RequestParams = {}) =>
      this.request<BankResponse, GenericError>({
        path: `/api/promissory-notes/v1/external/banks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Соглашения
     * @name GetAllAgreement
     * @summary Получение списка соглашений
     * @request GET:/api/promissory-notes/v1/external/agreement
     * @secure
     */
    getAllAgreement: (
      query: GetAllAgreementParams,
      params: RequestParams = {}
    ) =>
      this.request<AgreementList, GenericError>({
        path: `/api/promissory-notes/v1/external/agreement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Соглашения
     * @name GetDetail
     * @summary Получение детальной информации о соглашение
     * @request GET:/api/promissory-notes/v1/external/agreement/{id}
     * @secure
     */
    getDetail: (id: string, params: RequestParams = {}) =>
      this.request<AgreementDetail, GenericError>({
        path: `/api/promissory-notes/v1/external/agreement/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Соглашения
     * @name PrintAgreement
     * @summary Получение ПФ соглашения о приобретении/досрочном выкупе векселей
     * @request GET:/api/promissory-notes/v1/external/agreement/print/{id}
     * @secure
     */
    printAgreement: (id: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/promissory-notes/v1/external/agreement/print/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета
     * @name GetOpenedClientAccounts
     * @summary Получение списка счетов клиента
     * @request GET:/api/promissory-notes/v1/external/accounts
     * @secure
     */
    getOpenedClientAccounts: (params: RequestParams = {}) =>
      this.request<Account[], GenericError>({
        path: `/api/promissory-notes/v1/external/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
